import React, { useMemo } from "react";
import { Modal } from "../../SharedComponents";
import { ModalNames } from "../../../Constants/modalNames";
import { Div, Icon, Text } from "../../Kit";
import { useLanguage } from "../../../Store/modules/language";
import { Button } from "../../Kit/Button";
import { useModal } from "../../../Store/modules/modal/modal";
import { Trans } from "react-i18next";
import i18n from "i18next";
import { separate } from "../../../Utils";
import { Add } from "iconsax-react";
import settings from "../../../settings/settings";
import { useTheme } from "../../../Store/modules/theme";
import { useChoosePurchaseModel } from "../../../Store/modules/ai/choosePurchaseModel/choosePurchaseModel";
import { useBuySubscriptionPlan } from "../../../Store/modules/ai/buySubscriptionPlan/buySubscriptionPlan";

export const ConfirmationModal: React.FC = () => {
  const { direction } = useLanguage();
  const { modalProps, dispatchCloseModal } = useModal();
  const { name: theme } = useTheme();
  const { title, price, onConfirm, type } = modalProps || {};
  const { choosePurchaseModelLoading } = useChoosePurchaseModel();
  const { buySubscriptionPlanLoading } = useBuySubscriptionPlan();
  const loading = useMemo(() => {
    if (type === "purchaseModel") {
      return choosePurchaseModelLoading;
    }
    if (type === "subscription") {
      return buySubscriptionPlanLoading;
    }
    return false;
  }, [buySubscriptionPlanLoading, choosePurchaseModelLoading, type]);

  return (
    <Modal
      modalName={ModalNames.ConfirmationModal}
      modalClassName="rounded-[10px] relative w-[327px] flex flex-col justify-between items-center"
    >
      <Div
        bg="forthOpt"
        className="w-[27px] h-[27px] flex items-center justify-center pointer rounded-[50%] absolute right-[10px] top-[10px] "
        onClick={() => dispatchCloseModal()}
      >
        <Icon
          Component={Add}
          size={20}
          className="rotate-[45deg]"
          color="text"
        />
      </Div>
      <div dir={direction} className="flex justify-center pt-[10px]">
        <img src={settings.logo?.[theme]} alt="logo" className="w-[60px]" />
      </div>
      <div className="py-5 text-center">
        {modalProps.title ? (
          <Trans
            i18nKey="confirmationModal.details"
            className="text-center"
            i18n={i18n}
            dir={direction}
            values={{
              price: separate(price),
              title,
            }}
            components={{
              Price: <Text elementType="span" fontWeight={500} />,
              Title: <Text elementType="p" fontWeight={500} />,
              Text: (
                <Text
                  elementType="p"
                  fontWeight={400}
                  translatable={false}
                  lineHeight={1.9}
                />
              ),
            }}
          />
        ) : null}
      </div>
      <div className="flex flex-col items-center justify-center">
        <Button
          title="confirmationModal.confirmPayment"
          className="w-full h-[45px] mt-[14px]"
          textClassName="text-sm"
          loading={loading}
          bg="primary"
          onClick={onConfirm}
        />
      </div>
    </Modal>
  );
};
